import React from 'react';
import { Crosshair, MapPin } from 'lucide-react';
import UIButton from '../controls/Button';

export default function GeoActionRow({
  onGetCurrentLocation,
  onPickOnMap,
  isLocating = false,
  hint = '',
  className = '',
}) {
  return (
    <div className={className}>
      <div className="flex flex-wrap items-center gap-2">
        <UIButton type="button" variant="subtle" onClick={onGetCurrentLocation} disabled={isLocating}>
          <Crosshair className="h-3.5 w-3.5" />
          {isLocating ? 'Mengambil Lokasi...' : 'Dapatkan Lokasi Terkini'}
        </UIButton>
        <UIButton type="button" variant="ghost" onClick={onPickOnMap}>
          <MapPin className="h-3.5 w-3.5" />
          Pilih di Peta
        </UIButton>
      </div>
      {hint ? <p className="mt-1 text-[11px] text-[#7f93ac]">{hint}</p> : null}
    </div>
  );
}

